import { useSyncExternalStore } from 'react';
import { MOBILE_QUERY } from '../theme';

// The layout lives in inline styles, so the portrait breakpoint has to be read
// in JS rather than expressed as a media query. One module-level MediaQueryList,
// shared by every component that asks. Absent under jsdom, where the desktop
// layout is the sensible answer.
const mq = window.matchMedia ? window.matchMedia(MOBILE_QUERY) : null;

const subscribe = (cb) => {
    if (!mq) return () => {};
    mq.addEventListener('change', cb);
    return () => mq.removeEventListener('change', cb);
};

const getSnapshot = () => (mq ? mq.matches : false);

export default function useIsMobile() {
    return useSyncExternalStore(subscribe, getSnapshot);
}
